import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const passwordSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    changePassword: build.mutation({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/users/change-password`,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useChangePasswordMutation } = passwordSlice
